import React, { Component } from 'react';
import { Col, Container, Row, Card, CardBody, Nav, NavItem, NavLink } from 'reactstrap';
import { withTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import HorizontalForm from './components/UploadBrandMaster';
import HorizontalFormView from '../ViewBrandMaster/components/ViewBrandMaster';
import "../../global.css";

class UploadBrandMaster extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 'upload'
    };
  }

  toggleTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  };

  render() {
    const { t } = this.props;
    const { activeTab } = this.state;

    return (
      <Container>
        
        <Row>
          <Col md={12} id="master_tab_container" className="master_tab_container">
           
                <Nav style={{backgroundColor: '#fff', marginBottom: 6, paddingLeft: 0}} tabs>
                  <NavItem>
                    <NavLink
                      className={classnames({ active1: activeTab === 'upload' })}
                      style={activeTab === 'upload' ? { backgroundColor: '#FEF1CC', margin: 0 } : {}}
                      onClick={() => this.toggleTab('upload')}
                    >
                      Upload
                    </NavLink>
                  </NavItem>
                  <NavItem>
                    <NavLink
                      className={classnames({ active1: activeTab === 'view' })}
                      style={activeTab === 'view' ? { backgroundColor: 'yellow', border: '2px solid darkgoldenrod' } : {}}
                      onClick={() => this.toggleTab('view')}
                    >
                      View
                    </NavLink>
                  </NavItem>
                </Nav>
              
          </Col>
        </Row>

        
        <Row>
          <Col md={12}>
           
                {activeTab === 'upload' ? <HorizontalForm /> : <HorizontalFormView />}
             
          </Col>
        </Row>
      </Container>
    );
  }
}

UploadBrandMaster.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation('common')(UploadBrandMaster);

